import IncidentMarker from '../display/markers/IncidentMarker';

export default class IncidentDetailsMarkersManager {
    constructor(markerOptions, diff = true, map) {
        this.incidentMarkers = {};
        this.diff = diff;
        this.markerOptions = markerOptions;
        this.map = map;
    }

    addMarkers(incidents) {
        return this.diff ? this._withDiff(incidents) : this._withoutDiff(incidents);
    }

    clearMarkers() {
        Object.keys(this.incidentMarkers).forEach((marker) => {
            this.incidentMarkers[marker].remove();
        });

        this.incidentMarkers = Object.create(null);
    }

    _withoutDiff(incidents) {
        this.clearMarkers();
        incidents.toGeoJson().features.forEach((feature) => {
            this._addMarker(feature);
        });
    }

    _withDiff(incidents) {
        const newMarkers = this._mapResponseToFeaturesDictionary(incidents);
        /**
         * Diff steps:
         * 1. Iterate over all existing markers
         * 2. If newMarkers doesn't contain the element, then remove EXISTING marker
         * 3. If newMarkers contain the element, then update EXISTING marker and remove
         * updated marker from the list, so it is not added twice
         * 4. Add all remaining new markers.
         */
        Object.keys(this.incidentMarkers).forEach((featureId) => {
            if (!newMarkers[featureId]) {
                this.incidentMarkers[featureId].remove();
                delete this.incidentMarkers[featureId];
            } else {
                this.incidentMarkers[featureId].update(newMarkers[featureId]);
                delete newMarkers[featureId];
            }
        });
        Object.values(newMarkers).forEach((feature) => {
            this._addMarker(feature);
        });
    }

    _addMarker(feature) {
        const featureId = feature.properties.id;
        const marker = new IncidentMarker(this.markerOptions, feature);

        this.incidentMarkers[featureId] = marker;
        marker.addTo(this.map);
    }

    _mapResponseToFeaturesDictionary = (response) => {
        return response.toGeoJson().features.reduce((result, feature) => {
            const current = {};
            current[feature.properties.id] = feature;
            return Object.assign(result, current);
        }, Object.create(null));
    };

    getMarkers = () => {
        const markers = {};
        Object.keys(this.incidentMarkers).forEach((featureId) => {
            markers[featureId] = this.incidentMarkers[featureId].getMarker();
        });
        return markers;
    }

}



// WEBPACK FOOTER //
// ./map/tier/trafficIncidentDetailsMarkersManager.js